import { configureStore } from "@reduxjs/toolkit";
import formDataReducer from "../Reduser/Reducer"; // ✅ Correct default import

export const ReduxStore = configureStore({
    reducer: {
        form8: formDataReducer
    }
});
